import React, {useState, useEffect} from "react";
import {Container, Navbar, NavDropdown} from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';

import "./Header.css";
import Button from "react-bootstrap/Button";
import {faCloud, faCopy, faDownload, faHouseSignal, faX, faMoon, faSun} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {ReactComponent as Logo} from "./logo.svg";
import {faCircleQuestion} from "@fortawesome/free-regular-svg-icons";
import InputGroup from "react-bootstrap/InputGroup";

import help_1 from "./assets/help_1.png";
import help_2 from "./assets/help_2.png";
import help_3 from "./assets/help_3.png";
import help_bt_1 from "./assets/help_bt_1.png";
import {forceReload} from "../../lib/utils/index";
import {faBluetoothB} from "@fortawesome/free-brands-svg-icons";


function Header({bondApiType, setBondApiType, isSetupMode, setMateDebug}) {

    const [isReloading, setIsReloading] = useState(null);
    const [showHelp, setShowHelp] = useState(false);
    const [theme, setTheme] = useState(() => {
        // Initialize theme from localStorage or default to dark
        return localStorage.getItem('theme') || 'dark';
    });

    // Apply theme on mount and when theme changes
    useEffect(() => {
        document.documentElement.setAttribute('data-bs-theme', theme);
        localStorage.setItem('theme', theme);
    }, [theme]);

    function forceReloadClick() {
        forceReload();
        setIsReloading(true);
    }

    function toggleTheme() {
        setTheme(prevTheme => prevTheme === 'dark' ? 'light' : 'dark');
    }

    return (<>
        <Navbar expand={false} className="bg-body-tertiary mb-2">
            <Container fluid className={"justify-content-between"}>
                <div className="d-flex align-items-center">
                    <Button variant="outline" onDoubleClick={forceReloadClick}>
                        <Logo
                            width={30}
                            height={30}
                            alt={"Bond Palantir"}
                            className={isReloading ? "fa-bounce" : ""}
                        />
                    </Button>
                    <span className="navbar-brand mb-0 h1 ms-2">
                        Bond{" "}
                        <NavDropdown
                            title="Palantir"
                            id="tool-switcher-dropdown"
                            className="tool-switcher-dropdown d-inline-block"
                        >
                            <NavDropdown.Item
                                onClick={() => {
                                    window.location.hash = '#/';
                                }}
                            >
                                Dashboard
                            </NavDropdown.Item>
                            <NavDropdown.Item active>
                                Palantir
                            </NavDropdown.Item>
                        </NavDropdown>
                    </span>
                </div>
                <div>
                    <Navbar.Text>
                        <Button
                            variant={"outline-secondary"}
                            className={"me-2"}
                            size="sm"
                            onClick={toggleTheme}
                            title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
                        >
                            <FontAwesomeIcon icon={theme === 'dark' ? faSun : faMoon} />
                        </Button>
                        <Button
                            variant={"outline-secondary"}
                            className={"me-2"}
                            size="sm"
                            onClick={() => {
                                setShowHelp(true);
                            }}
                        >
                            <FontAwesomeIcon icon={faCircleQuestion} />
                        </Button>
                        {!isSetupMode && (
                            <>
                                <Button
                                    variant={bondApiType === "cloud" ? "outline-primary" : "outline-info"}
                                    className={"me-2"}
                                    size="sm"
                                    onClick={() => {
                                        setBondApiType(bondApiType === "cloud" ? "local" : "cloud")
                                    }}
                                >
                                    <FontAwesomeIcon icon={bondApiType === "cloud" ? faCloud : faHouseSignal} />
                                </Button>
                                <Button
                                    variant={"primary"}
                                    size="sm"
                                    onClick={setMateDebug}
                                >
                                    <FontAwesomeIcon icon={faBluetoothB} />
                                </Button>
                            </>
                        )}
                    </Navbar.Text>
                </div>
            </Container>
        </Navbar>

        <Modal className={"modalHelp"} show={showHelp} size={"lg"} onHide={() => {
            setShowHelp(false);
        }}>
            <Modal.Header closeButton>
                <Modal.Title className={"text-center w-100"}>Bond Palantir 🔮 Help</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <li>Download Google Chrome extension</li>
                <div className={"text-sm-center"}>
                    <Button variant="success" size={"lg"} href={"/download/bond-palantir.zip"} download>
                        <FontAwesomeIcon icon={faDownload}/> Download
                    </Button></div>
                <li>Extract the content of the zip file</li>
                <li>Go to the extension settings: (copy/paste)</li>
                <div className={"text-sm-center chromeUrl"}>
                    <InputGroup>
                        <InputGroup.Text readOnly>chrome://extensions
                        </InputGroup.Text>
                        <Button variant="outline-secondary" onClick={(e) => {
                            navigator.clipboard.writeText("chrome://extensions");
                            document.getElementById("copyLabel").classList.toggle("visible");
                        }}>
                            <FontAwesomeIcon icon={faCopy}/>
                        </Button>
                        <label className={"ps-2"} id={"copyLabel"}>copied to clipboard</label>
                    </InputGroup>
                </div>
                <li>
                    Enable Developer mode (top right)
                    <div className={"text-sm-center w-100"}>
                        <img src={help_1} alt={"Developer mode"}/>
                    </div>
                </li>
                <li>
                    Load the extension by selecting the unzipped folder
                    <div className={"text-sm-center w-100"}>
                        <img src={help_2} alt={"Developer mode"}/>
                    </div>
                </li>
                <li>
                    Check the integration and pin it!
                    <div className={"text-sm-center w-100"}>
                        <img src={help_3} alt={"Developer mode"}/>
                    </div>
                </li>
                <hr/>
                <h3 className={"text-sm-center pt-2"}>Bluetooth - enable new permissions:</h3>
                <li>Go to the flags page: (copy/paste)</li>
                <div className={"text-sm-center chromeUrl"}>
                    <InputGroup>
                        <InputGroup.Text readOnly>chrome://flags/#enable-web-bluetooth-new-permissions-backend
                        </InputGroup.Text>
                        <Button variant="outline-secondary" onClick={(e) => {
                            navigator.clipboard.writeText("chrome://flags/#enable-web-bluetooth-new-permissions-backend");
                            document.getElementById("copyLabelFlags").classList.toggle("visible");
                        }}>
                            <FontAwesomeIcon icon={faCopy}/>
                        </Button>
                        <label className={"ps-2"} id={"copyLabelFlags"}>copied to clipboard</label>
                    </InputGroup>
                </div>
                <li>Enable and restart</li>
                <img src={help_bt_1} alt={"enable"}/>
                <li>To clear paired devices:</li>
                <div className={"text-sm-center chromeUrl"}>
                    <InputGroup>
                        <InputGroup.Text readOnly>chrome://settings/content/bluetoothDevices
                        </InputGroup.Text>
                        <Button variant="outline-secondary" onClick={(e) => {
                            navigator.clipboard.writeText("chrome://settings/content/bluetoothDevices");
                            document.getElementById("copyLabelFlags").classList.toggle("visible");
                        }}>
                            <FontAwesomeIcon icon={faCopy}/>
                        </Button>
                        <label className={"ps-2"} id={"copyLabelFlags"}>copied to clipboard</label>
                    </InputGroup>
                </div>

            </Modal.Body>
        </Modal>

    </>);
}

export default Header;
